import Api from "../../Api"
import Request from "services/constants/Request.api"
const SERVICE_ID = 17003

class EnvAuditService extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  // Get all checklist reviews
  getAllChecklistQuestions = () => {
    const request = new Request({
      data: {
        url: "environment-check-list",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // Create a new checklist review question
  createChecklistQuestion = data => {
    const request = new Request({
      data: {
        url: "environment-check-list",
        ...data, // New checklist review data
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  // Update an existing checklist review question
  updateChecklistQuestion = (id, data) => {
    const request = new Request({
      data: {
        url: `environment-check-list/${id}`,
        ...data, // Updated checklist review data
        token: "Bearer " + this.user.token,
      },
    })

    return this.putRequest(request)
  }

  // Delete a checklist review question
  deleteChecklistQuestion = id => {
    const request = new Request({
      data: {
        url: `environment-check-list/${id}`,
        token: "Bearer " + this.user.token,
      },
    })

    return this.deleteRequest(request)
  }

  // Application checklist reviewed and submitted by officer
  createApplicationChecklist = data => {
    const request = new Request({
      data: {
        url: "application/environment-check-list",
        ...data,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getApplicationChecklist = id => {
    const request = new Request({
      data: {
        url: "application/environment-check-list/" + id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getProjectLocations = appId => {
    const request = new Request({
      data: {
        url: "environmental-request/locations/" + appId,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getSectorOfActivities = () => {
    const request = new Request({
      data: {
        url: "sector-of-activity",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  createSectorOfActivity = data => {
    const request = new Request({
      data: {
        url: "sector-of-activity",
        ...data,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  updateSectorOfActivity = (id, data) => {
    const request = new Request({
      data: {
        url: `sector-of-activity/${id}`,
        ...data,
        token: "Bearer " + this.user.token,
      },
    })

    return this.putRequest(request)
  }
  deleteSectorOfActivity = id => {
    const request = new Request({
      data: {
        url: `sector-of-activity/${id}`,
        token: "Bearer " + this.user.token,
      },
    })

    return this.deleteRequest(request)
  }

  // Dashboard APIs
  // officer
  // /environmental-audit/tor-applications-assigned/{staff_id}
  getOfficerAssignedApplications = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/tor-applications-assigned/" + this.user.id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // /environmental-audit/tor-drafted-applications/{staff_id}
  getOfficerDraftedApplications = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/tor-drafted-applications/" + this.user.id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // /environmental-audit/applications-waiting-report/{staff_id}
  getOfficerWaitingReports = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/applications-waiting-report/" + this.user.id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // /environmental-audit/applications-reports-review/{staff_id}
  getOfficerReportsReview = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/applications-reports-review/" + this.user.id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // /environmental-audit/applications-drafted-certificate/{staff_id}
  getOfficerDraftedCertificates = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/applications-drafted-certificate/" + this.user.id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // /environmental-audit/all-applications
  getAllApplications = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/all-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // /environmental-audit/officer-statistics/{staff_id}
  getOfficerStatistics = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/officer-statistics/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // End of Officer Dashboard

  // Division Manager Dashboard
  getDMDraftedApplications = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/officer-reviewed-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDMDraftedEACertificate = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/drafted-ea-certificate" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDMApprovedApplications = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/approved-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDMStatistics = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/dm-dashboard",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
  // End of Division Manager Dashboard

  // DG Dashboard
  getDGToRApplications = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/dm-reviewed-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })
    return this.getRequest(request)
  }

  getDGEACertificate = (page) => {
    const request = new Request({
      data: {
        url: "environmental-audit/dm-approved-ea-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })
    return this.getRequest(request)
  }

  getDGStatistics = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/dg-statistics",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // End of DG Dashboard

  // End of Dashboard APIs


  // DM Pending Applications. DM Pending
  getOfficerReviewedApplications = (page) => {
    const request = new Request({
      data: {
        url:
          "applications/reviewed/departments/service/" +
          SERVICE_ID + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // These are freshly submitted applications yet to be assigned to officer
  // Division Manager/HoD will query this.
  // /applications/submitted/departments/service/{service_id}
  getSubmittedApplications = (page) => {
    const request = new Request({
      data: {
        url:
          "applications/submitted/departments/service/" + SERVICE_ID + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  updateTermsOfReference = data => {
    const request = new Request({
      data: {
        url: "environmental-audit/application/update-tor",
        ...data,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

   getToRApprovedApplications = (page) => {
    const request = new Request({
      data: {
        url:
          "environmental-audit/tor-approved-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
}

export default EnvAuditService
